/**
 * 「たった今」「10 分前」「2 時間前」のような相対時刻表示。
 *
 * 設計意図:
 *   - アクセスログのプレビューなど、人間が「ざっくり最近」を読み取りたい場面用
 *   - 1 日を超える場合は曖昧さが増すので絶対日付に切替（`2026/5/17`）
 *   - 厳密にしすぎず（秒・ミリ秒は丸める）、低リテラシーでも読み取れる粒度
 *   - i18n は今のところ日本語固定（用語辞書 labels.ts と同方針）
 */

const SECOND_MS = 1000
const MINUTE_MS = 60 * SECOND_MS
const HOUR_MS = 60 * MINUTE_MS
const DAY_MS = 24 * HOUR_MS

export function formatRelativeTime(input: Date | string, now: Date = new Date()): string {
  const date = typeof input === 'string' ? new Date(input) : input
  const diffMs = now.getTime() - date.getTime()
  // 未来時刻（時計ずれ・タイムゾーン誤差で起こりうる）は「たった今」に丸める
  if (diffMs < MINUTE_MS) return 'たった今'
  if (diffMs < HOUR_MS) return `${Math.floor(diffMs / MINUTE_MS)}分前`
  if (diffMs < DAY_MS) return `${Math.floor(diffMs / HOUR_MS)}時間前`
  if (diffMs < 7 * DAY_MS) return `${Math.floor(diffMs / DAY_MS)}日前`
  return date.toLocaleDateString('ja-JP')
}
